// Action Types
export const SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST = "SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST";
export const SUBMIT_OPERATIONS_SUPPLY_CHAIN_SUCCESS = "SUBMIT_OPERATIONS_SUPPLY_CHAIN_SUCCESS";
export const SUBMIT_OPERATIONS_SUPPLY_CHAIN_FAILURE = "SUBMIT_OPERATIONS_SUPPLY_CHAIN_FAILURE";

// Action Creators
export const submitOperationsAndSupplyChainRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_OPERATIONS_SUPPLY_CHAIN_REQUEST,
      payload: formData,
    });
  };
};

export const submitOperationsAndSupplyChainSuccess = (message) => ({
  type: SUBMIT_OPERATIONS_SUPPLY_CHAIN_SUCCESS,
  payload: message,
});

export const submitOperationsAndSupplyChainFailure = (error) => ({
  type: SUBMIT_OPERATIONS_SUPPLY_CHAIN_FAILURE,
  payload: error,
});